import encryption from './encryption';

const fromUint8ArrayToBase64 = (array: Uint8Array): string => Buffer.from(array).toString('base64');

const fromBase64ToUint8Array = (base64String: string): Uint8Array =>
  new Uint8Array(Buffer.from(base64String, 'base64'));

const fromBase64ToObjectWithDecryption = async <T>(base64String: string): Promise<T> => {
  const u8 = fromBase64ToUint8Array(base64String);
  const decrypted = await encryption.decrypt(u8);
  return JSON.parse(decrypted);
};

const fromObjectToBase64WithEncryption = async <T>(obj: T): Promise<string> => {
  const jsonObj = JSON.stringify(obj);
  const encrypted = await encryption.encrypt(jsonObj);
  return fromUint8ArrayToBase64(encrypted);
};

const transformer = {
  fromUint8ArrayToBase64,
  fromBase64ToUint8Array,
  fromBase64ToObjectWithDecryption,
  fromObjectToBase64WithEncryption,
};

export default transformer;
